export default "/images/vendor/flag-icons/flags/1x1/si.svg?3900235bcc3b49301cac80776f5c0745";